import styled from '@emotion/styled';

import { Button, Link } from '@/shared/design-system';
import { typographyVariantStyles } from '@/shared/design-system/typography-variants';

export const PasswordRevealControl = styled(Button)(({ theme }) => ({
  position: 'relative',
  width: 32,
  minWidth: 32,
  height: 32,
  padding: 0,
  backgroundColor: theme.colors.black[0],

  '&::after': {
    position: 'absolute',
    inset: -6,
    content: '""',
  },

  '& svg': {
    width: 16,
    height: 16,
  },
}));

export const AuthInlineLinkRoot = styled(Link, {
  shouldForwardProp: (prop) => prop !== '$tone',
})<{ $tone: 'brand' | 'inherit' }>(({ theme, $tone }) => ({
  position: 'relative',
  padding: 0,
  borderRadius: 0,
  color: $tone === 'inherit' ? 'inherit' : theme.colors.brand.text,
  ...typographyVariantStyles.body3,
  fontWeight: 500,

  '&::before': {
    position: 'absolute',
    inset: '-12px -8px',
    content: '""',
  },
}));

export const AuthDividerRoot = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing[16],
  color: theme.colors.text.secondary,

  '& > [role="separator"]': {
    flex: 1,
    alignSelf: 'center',
  },
}));

export const SessionHandoffErrorRoot = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing[12],
  padding: theme.spacing[16],
  border: `1px solid ${theme.colors.error.border}`,
  borderRadius: theme.radius[12],
  backgroundColor: theme.colors.error.subtle,
}));

export const SessionHandoffErrorActions = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing[8],

  '& > button': {
    width: '100%',
    height: theme.spacing[48],
  },
}));

export const PasswordInputGroup = styled('fieldset')({
  width: '100%',
  minWidth: 0,
  margin: 0,
  padding: 0,
  border: 0,

  legend: {
    position: 'absolute',
    width: 1,
    height: 1,
    margin: -1,
    padding: 0,
    overflow: 'hidden',
    border: 0,
    clipPath: 'inset(50%)',
    whiteSpace: 'nowrap',
  },
});
